import { SEARCH_DATA_TIMESTAMP } from "../constants/actionTypes";
import { storagedSearchDataManager } from "../helpers/domHelpers";
import { SEARCH_DATA_STORE_PARAMETERS_MAPPING } from "../constants/general";

export const updateSearchDataInSessionStorage = () => (dispatch, getState) => {
  const searchData = {};
  const store = getState();

  Object.entries(SEARCH_DATA_STORE_PARAMETERS_MAPPING).forEach(
    ([storeKey, searchDataKey]) => {
      searchData[searchDataKey] = store[storeKey];
    }
  );

  storagedSearchDataManager().addNewSearchData(searchData);

  dispatch(setSearchDataTimestamp(new Date().getTime()));
};

export const setSearchDataTimestamp = timestamp => {
  return {
    type: SEARCH_DATA_TIMESTAMP,
    payload: timestamp
  };
};



// WEBPACK FOOTER //
// ./src/actions/searchDataActions.js